import React from 'react'
import styles from './ProjectInfoTags.module.scss'

const ProjectInfoTags: React.FC<{ tags: { id: number, name: string }[]}> = ({ tags }) => {
  const tagNames = tags.map(t => t.name)

  return <div className={styles.tags}>
    {tagNames.map((tag, idx) => <span className={styles.tag} key={idx}>{tag}</span>)}
  </div>
}

export default ProjectInfoTags
